import React, { useRef, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Home() {
  const reviewsGridRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.fade-in-up');
    animatedElements.forEach(el => observer.observe(el));

    // FAQ accordion functionality
    const handleFaqClick = (e) => {
      const question = e.currentTarget;
      const item = question.closest('.faq-item');
      const isActive = item.classList.contains('active');
      
      // Close all items
      document.querySelectorAll('.faq-item').forEach(faq => {
        faq.classList.remove('active');
        const toggle = faq.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '+';
      });
      
      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        const toggle = item.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '−';
      }
    };

    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
      question.addEventListener('click', handleFaqClick);
    });

    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
      faqQuestions.forEach(question => {
        question.removeEventListener('click', handleFaqClick);
      });
    };
  }, []);

  const scrollReviews = (direction) => {
    const grid = reviewsGridRef.current;
    if (grid) {
      const containerWidth = grid.offsetWidth;
      const scrollAmount = containerWidth / 3 + 15;
      grid.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <Header />
      
      <section className="hero">
        <div className="container">
          <h2>Hello, I'm Ansh Chopra</h2>
          <h1><span className="hero-line-1">DESIGNER+</span><br/><span className="hero-line-2">DEVELOPER</span></h1>
        </div>
      </section>

      <section className="bio-section fade-in-up" id="about">
        <div className="container">
          <div className="bio-content-centered">
            <p className="bio-text">
              Creative UI/UX Designer focused on crafting intuitive, user-centered digital experiences across web and mobile platforms. Skilled in wireframing, prototyping, visual design, and usability improvement. Passionate about clean aesthetics, problem-solving, and transforming ideas into functional interfaces that balance user needs with business goals while delivering engaging, modern, and accessible design solutions.
            </p>
            <a href="/contact" className="btn btn-black">Contact Now <span className="btn-arrow">→</span></a>

            <div className="clients-title">
              Featured Clients
            </div>
            <div className="clients-grid">
              <div className="clients-scroll">
                <div className="client-item"><span>&#10038;</span> Jungleworks</div>
                <div className="client-item"><span>&#10038;</span> Flash Delivery</div>
                <div className="client-item"><span>&#10038;</span> Solo Beauty</div>
                <div className="client-item"><span>&#10038;</span> Inamigos</div>
                <div className="client-item"><span>&#10038;</span> Nayepankh</div>
                <div className="client-item"><span>&#10038;</span> Alen Wokens</div>
                <div className="client-item"><span>&#10038;</span> Jungleworks</div>
                <div className="client-item"><span>&#10038;</span> Flash Delivery</div>
                <div className="client-item"><span>&#10038;</span> Solo Beauty</div>
                <div className="client-item"><span>&#10038;</span> Inamigos</div>
                <div className="client-item"><span>&#10038;</span> Nayepankh</div>
                <div className="client-item"><span>&#10038;</span> Alen Wokens</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section container fade-in-up" id="services">
        <div className="section-title-big">Services</div>
        <div className="services-list">
          <div className="service-item">
            <div className="service-number">[01]</div>
            <div className="service-name">UX Design and Prototyping</div>
            <div className="service-details">
              <div className="service-tags">User Research • Wireframing • Interactive Prototypes</div>
              <div className="service-desc">Creating intuitive user experiences through research-driven design, wireframing, and interactive prototypes that validate concepts before development.</div>
            </div>
          </div>

          <div className="service-item">
            <div className="service-number">[02]</div>
            <div className="service-name">UI Design and Branding</div>
            <div className="service-details">
              <div className="service-tags">Visual Identity • Interface Design • Brand Guidelines</div>
              <div className="service-desc">Crafting beautiful, cohesive visual identities and user interfaces that reflect brand values and create memorable digital experiences.</div>
            </div>
          </div>

          <div className="service-item">
            <div className="service-number">[03]</div>
            <div className="service-name">Research and Strategy</div>
            <div className="service-details">
              <div className="service-tags">User Testing • Analytics • Product Strategy</div>
              <div className="service-desc">Data-driven insights through user research, competitive analysis, and strategic planning to inform design decisions and drive business goals.</div>
            </div>
          </div>

          <div className="service-item">
            <div className="service-number">[04]</div>
            <div className="service-name">Development</div>
            <div className="service-details">
              <div className="service-tags">Frontend • Responsive Design • Performance Optimization</div>
              <div className="service-desc">Transforming designs into high-performance, responsive web applications with clean code, modern frameworks, and seamless user interactions.</div>
            </div>
          </div>

          <div className="service-item">
            <div className="service-number">[05]</div>
            <div className="service-name">Video Editing <span style={{fontSize: '14px', fontWeight: '400', color: 'rgb(102, 102, 102)', marginLeft: '10px'}}>Starting Soon</span></div>
            <div className="service-details">
              <div className="service-tags">Motion Graphics • Color Grading • Post Production</div>
              <div className="service-desc">Professional video editing services bringing your visual stories to life with creative transitions, effects, and polished post-production quality.</div>
            </div>
          </div>
        </div>
      </section>

      <section className="projects-section container fade-in-up">
        <h2 className="centered-title">PROJECTS</h2>
        <div className="projects-grid">
          <div className="project-card">
            <a href="/projects/solo-beauty">
              <img src="/assets/WhatsApp Image 2026-02-17 at 8.31.55 PM.jpeg" alt="Solo Beauty Project" />
            </a>
            <div className="project-title">Solo Beauty</div>
            <p className="project-desc">Solo Beauty is a beauty and skincare brand offering personalized cosmetic products and digital solutions, helping users discover, explore, and purchase tailored beauty essentials seamlessly.</p>
            <a href="/projects/solo-beauty" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/flash-delivery">
              <img src="/assets/flash-delivery-cover.jpeg" alt="Flash Delivery Project" />
            </a>
            <div className="project-title">Flash Delivery</div>
            <p className="project-desc">Flash Delivery is a quick-commerce platform that enables ultra-fast delivery of groceries and daily essentials, ensuring convenience, speed, and seamless last-mile fulfillment for customers.</p>
            <a href="/projects/flash-delivery" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/liveeasy">
              <img src="/assets/Screenshot 2026-02-17 213827.png" alt="LIVEASY Project" />
            </a>
            <div className="project-title">Liveasy</div>
            <p className="project-desc">LIVEASY is a technology-driven logistics company connecting shippers and truckers, streamlining freight operations, optimizing routes, and improving supply chain efficiency through digital solutions.</p>
            <a href="/projects/liveeasy" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>

          <div className="project-card">
            <a href="/projects/personal-work">
              <img src="/assets/WhatsApp Image 2026-02-18 at 5.12.42 PM.jpeg" alt="Personal Project" />
            </a>
            <div className="project-title">This is what I do in my free time</div>
            <p className="project-desc">A creative exploration of personal interests and experimental design work, showcasing passion projects and innovative concepts developed outside client work.</p>
            <a href="/projects/personal-work" className="btn">View Project <span className="btn-arrow">→</span></a>
          </div>
        </div>
      </section>

      <section className="experience-section container fade-in-up">
        <div className="experience-title-block">
          <h2>WORK</h2>
          <h2>EXPERIENCE</h2>
        </div>

        <div className="job-list">
          <div className="job-item">
            <div className="job-role">UI/UX Designer</div>
            <div className="job-company">
              <span className="company-name">Flash Delivery</span>
              <span className="company-date">Current</span>
            </div>
          </div>

          <div className="job-item">
            <div className="job-role">UI/UX Designer</div>
            <div className="job-company">
              <span className="company-name">Solo Beauty</span>
              <span className="company-date">Current</span>
            </div>
          </div>

          <div className="job-item">
            <div className="job-role">Graphic Designer</div>
            <div className="job-company">
              <span className="company-name">Inamigos Foundation</span>
              <span className="company-date">Sept - Nov 2024</span>
            </div>
          </div>

          <div className="job-item">
            <div className="job-role">Freelancing</div>
            <div className="job-company">
              <span className="company-name">Self-Employed</span>
              <span className="company-date">2024 - Present</span>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section container fade-in-up">
        <div className="stats-title">
          SOME<br/>NUMBERS
        </div>
        <div className="stats-grid">
          <div className="stat-item">
            <h3>1</h3>
            <p>Year of experience</p>
          </div>
          <div className="stat-item">
            <h3>9+</h3>
            <p>Projects Completed</p>
          </div>
          <div className="stat-item">
            <h3>4</h3>
            <p>Award winner</p>
          </div>
          <div className="stat-item">
            <h3>98%</h3>
            <p>Clients satisfied</p>
          </div>
          <div className="stat-item">
            <h3>3</h3>
            <p>Industries served</p>
          </div>
        </div>
      </section>

      <section className="reviews-section fade-in-up">
        <div className="container">
          <div className="reviews-header">
            <h2 className="reviews-title">CLIENT<br/>REVIEWS</h2>
            <div className="reviews-nav">
              <button className="nav-arrow" onClick={() => scrollReviews(-1)}>←</button>
              <button className="nav-arrow" onClick={() => scrollReviews(1)}>→</button>
            </div>
          </div>

          <div className="reviews-grid" ref={reviewsGridRef}>
            <div className="review-card">
              <p className="review-text">"Working with Ansh on our app redesign was a game-changer. His creative vision and focus on user experience made a massive impact on our engagement metrics."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=33" alt="Rajesh Kumar" />
                </div>
                <div className="reviewer-details">
                  <h4>Rajesh Kumar</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Ansh brought a fresh perspective to our brand identity. His design expertise and understanding of our market made a huge difference in our product launch."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=27" alt="Sarah Mitchell" />
                </div>
                <div className="reviewer-details">
                  <h4>Sarah Mitchell</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Exceptional attention to detail and a deep understanding of modern design principles. Ansh delivered beyond our expectations and on time."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=12" alt="Priya Sharma" />
                </div>
                <div className="reviewer-details">
                  <h4>Priya Sharma</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"His ability to translate complex requirements into intuitive designs is remarkable. The collaboration was smooth and the results speak for themselves."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=52" alt="Michael Chen" />
                </div>
                <div className="reviewer-details">
                  <h4>Michael Chen</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Ansh's strategic approach to UX design helped us reduce bounce rates by 40%. His insights into user behavior were invaluable to our success."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=47" alt="Amit Patel" />
                </div>
                <div className="reviewer-details">
                  <h4>Amit Patel</h4>
                </div>
              </div>
            </div>

            <div className="review-card">
              <p className="review-text">"Professional, creative, and incredibly responsive. Ansh transformed our vision into a beautiful, functional product that our users love."</p>
              <div className="reviewer-info">
                <div className="reviewer-avatar">
                  <img src="https://i.pravatar.cc/150?img=20" alt="Emma Thompson" />
                </div>
                <div className="reviewer-details">
                  <h4>Emma Thompson</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <div className="container">
          <div className="faq-container">
            <div className="faq-title">
              <h2>FAQ</h2>
            </div>
            <div className="faq-list">
              <div className="faq-item active">
                <div className="faq-question">
                  <span>Can you work with wireframes or our existing designs?</span>
                  <button className="faq-toggle">−</button>
                </div>
                <div className="faq-answer">
                  <p>Yes, absolutely. I can work with your provided wireframes, mockups, or existing designs to ensure consistency and alignment with your vision.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>What happens after the design is ready & I approve it?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>Once approved, I'll prepare all design files, assets, and documentation for handoff. If development is needed, I can either implement it myself or provide detailed specifications for your development team.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>Do you charge for additional revisions?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>The initial project scope includes a set number of revision rounds. Additional revisions beyond the agreed scope may incur extra charges, which we'll discuss upfront.</p>
                </div>
              </div>

              <div className="faq-item">
                <div className="faq-question">
                  <span>What do I need to give you to get started?</span>
                  <button className="faq-toggle">+</button>
                </div>
                <div className="faq-answer">
                  <p>To get started, I'll need your project brief, target audience information, brand guidelines (if any), reference designs you like, and any existing assets or content you want to include.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Home;
